























import { Component, Vue } from 'vue-property-decorator';
import VueContentLoading from 'vue-content-loading';

@Component({
  components: { VueContentLoading },
})
export default class PreCollectionFilterLoading extends Vue {
  mounted() {
    const loadings: any = document.getElementsByClassName(
      'pre-collection-loading',
    );

    if (loadings) {
      loadings.forEach((loading: any) => {
        if (loading) {
          loading.removeAttribute('viewBox');
        }
      });
    }
  }
}
